<template>
  <div class="flex flex-col items-center gap-8">
    <RevButton
      :disabled="policyState === 'ON_HOLD'"
      full-width="always"
      :icon="IconExternalLink"
      target="_blank"
      :to="PARTNER_WEBSITE_URL[partnerName]"
      :tracking="{
        zone: TRACKING_ZONES.POLICY_DETAILS,
        name: 'submit-claim',
      }"
      variant="primary"
    >
      {{ i18n(translations.submitClaim) }}
    </RevButton>
    <div
      v-if="policyState === 'ON_HOLD'"
      class="text-static-default-low caption"
    >
      {{ i18n(translations.catchUpOnMissedPayments) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { IconExternalLink } from '@ds/icons/IconExternalLink'

import {
  PARTNER_WEBSITE_URL,
  TRACKING_ZONES,
} from '~/scopes/dashboard/services-hub/constant'
import type { PolicyDetails } from '~/scopes/dashboard/services-hub/types'

import translations from './SubmitClaim.translations'

const i18n = useI18n()

defineProps<{
  policyState: PolicyDetails['policy']['state']
  partnerName: PolicyDetails['policy']['offer']['partnerName']
}>()
</script>
